export const config = () => {
  // let CALL_SERVER_WSS_URL =  'wss://testtls.worktual.co.uk:57344';
  // let CALL_SERVER_WSS_URL = "wss://audiosgw.worktual.co.uk:57344";
  let CALL_SERVER_WSS_URL = "wss://testsgw8.worktual.co.uk:57344";

  //  let CALL_SERVER_WSS_URL =  'wss://testwebrtc1.worktual.co.uk:57344';

  // let CALL_SERVER_WSS_URL = "wss://testlwss3.worktual.co.uk:57344";
  let CALL_SERVER_STUN_URL_V4 = "turn:audioturnv4.worktual.co.uk:3478";
  let CALL_SERVER_STUN_URL_V6 = "turn:audioturnv6.worktual.co.uk:3478";
  let CALL_SERVER_STUN_USERNAME = "admin";
  let CALL_SERVER_STUN_PASSWORD = "system123";
  let CALL_SERVER_USER_AGENT = "URWEB:WEB";
  let CALLER_ID = "caller_id";
  let UNKNOW_CALLER = "Unknown Caller";
  let CALL_LOG_MISSED = "missedcall";
  let CALL_LOG_INCOMING = "incoming";
  let CALL_LOG_OUTGOING = "outgoing";
  let CALL_INVALID_NUMBER = "Please enter valid number";
  let SELF_USER_NUMBER ="You can not make a call to yourself";
  let ENTER_VALID_NUMBER = "Please enter number";
  let DEVICE_ALERT = "Please Check Your Devices";
  let FEATURE_IMP_ALTER = "Future implementation";
  let ADHOC_CONF_MERGE_ALERT = "Merge call not possible";
  let CALL_LOG_DELETED_SUCCESS = "call logs deleted successfully";
  let CALL_LOG_SELECTION_ALERT = "Please select atleast one log";
  let CALL_LOGALL_DELETED_SUCCESS = "All Call logs deleted successfully";
  let VOICEMAIL_READ = "Marked as read";
  let VOICEMAIL_UNREAD = "Marked as unread";
  let VOICEMAIL_DELETED = "Selected voicemail deleted successfully";
  let QUEUELOG_DELETED = "Selected queue log deleted successfullly";
  let VOICEMAIL_SHARED = "Selected voicemail shared successfully";
  let RECORDING_DELETED = "Selected recording deleted successfullly";
  let UR_WEB = "URWEB:WEB";
  let UR_ANDROID = "URAPP:AND";
  let UR_IOS = "URAPP:IOS";
  let DESK_PHONE = "URDESK:";
  let TRY_AGAIN = "Something went wrong Try again";
  let settingUp = 'Set up is in progress. Please wait';
  let ADD_CALL = "Call Added to";
  let TASKDELETE = "Task selected and deleted";
  let EVENTDELETE = "Event selected and deleted!";
  let TASKSUCCESS = "Success! Task created ";
  let TASKEDIT = "The task has been edited";
  let EVENTCREATE = "Success! Event Created";
  let EVENTEDIT = "The event has been edited";
  let FILEUPLOADFAIL = "File Upload Failed!! Please Try Again";
  let TEAMCREATIONSUCCESS = "Success! Contact group created";
  let FILEDELETED = "File Deleted Successfully";
  let IMAGEDELETED = "Success! Image deleted";
  let TEAMCREATIONFAIL = "Team Creation Failed";
  let NOTESUCCESS = "Success! Note created";
  let REMOVEPROFILE = "Profile picture removed successfully";
  let NOTEFAIL = "Notes Creation Failed";
  let NOTEUPDATE = "The note has been edited";
  let NOTEDELETE = "Selected note deleted successfully!";
  let SHAREMESSAGE = "Selected message shared";
  let DELETEMESSAGE = "That message was deleted";
  let CALL_TRANSFER = "Call transferred successfully!";
  let ADD_FAV = "Contact Added to Favourites";
  let REMOVE_FAV = "Contact removed from Favourites";
  let APIFAILURE = "Oops, something went wrong. Please try again";
  let COPYINVITATION = " Meeting Invitation Copied";
  let CHAT_RESTAPI_URL = "https://urapi.worktual.co.uk/urchat/v2";
  let MEET_RESTAPI_URL = "https://urapi.worktual.co.uk/urmeet/v2/meetings";
  let API_URL = "https://urapi.worktual.co.uk";
  let URCHAT_SOCKETIO_URL = "https://urchat-io.worktual.co.uk";
  let GOOGLE_API_URL =
    "https://translation.googleapis.com/language" + "/translate/v2?key=AIzaSyDqe_P-A7aLRGwuhsWqea8hHOTMBlyZmTo";
  let GOOGLE_COOKIE = "SameSite=Strict; Secure";
  let GOOGLE_DEVELOPER_KEY = "AIzaSyAqSFck7kRcfsDP6Jac-1ZCEYmK4sNAtRY";
  let GOOGLE_CLIENTID = "785426237527-40g5faqoqa3kpluoo3ejtpupiuohiaqu.apps.googleusercontent.com";
  let GOOGLE_APPID = "unifiedring-281507";
  let GOOGLE_SCOPE = [
    "https://www.googleapis.com/auth/drive.file",
    "https://www.googleapis.com/auth/drive",
    "https://www.googleapis.com/auth/drive.readonly",
    "https://www.googleapis.com/auth/drive.photos.readonly",
    "https://www.googleapis.com/auth/drive.metadata.readonly",
    "https://www.googleapis.com/auth/drive.metadata"
  ];
  let APPID = "844239";
  let AppSECRET = "kU9IPc0C65";
  let HELPCENTER = "https://worktual.co.uk/help/";
  let TPICB_URL = "https://tpicb.worktual.co.uk/cb";
  let ABOUT = "https://www.worktual.co.uk/";
  let ACCEPTED_FILE_TYPE =
    "pdf, application/pdf,image/png, image/jpeg, image/jpg, image/jfif, image/svg, image/webp, image/gif, image/svg+xml,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.openxmlformats-officedocument.spreadsheetml.template,application/vnd.google-apps.spreadsheet,application/vnd.ms-excel.sheet.macroEnabled.12,application/vnd.ms-excel.template.macroEnabled.12,application/vnd.ms-excel.addin.macroEnabled.12,application/vnd.ms-excel.sheet.binary.macroEnabled.12,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.openxmlformats-officedocument.wordprocessingml.template,application/vnd.ms-word.document.macroEnabled.12,application/vnd.ms-word.template.macroEnabled.12,application/x-zip-compressed";
  // let GOOGLE_CB_URL = 'https://tpicb.worktual.co.uk/cb/cloudstorage/google/gettokenprod';
  let meetingDomain = 'https://meet.worktual.co.uk';
  let queryBoxUrl = 'fields=id,name,type,size,parent,extension,permissions,path_collection,modified_at,created_at,modlet ified_by,has_collaborations,is_externally_owned,item_collection,authenticated_download_url,is_download_available,representations,url';
  let BOX_CLIENT_ID = 'sl2m7q73oum4svzx9rnrjtuuffmsjyli';
  let BOX_CLIENT_SECRET ='OgQePYKTqHnVrcxCJTlszwExsoufcxmU';
  let BOX_AUTH_URL ='https://account.box.com/api/oauth2/authorize';
  let BOX_BASE_URL = 'https://api.box.com/2.0/';
  let MyAccountURL="https://myaccount.worktual.co.uk";
  let CCAASS_URL="https://ccaas.worktual.co.uk/agentDashboard";
  let DEACTIVATED_URL = "https://mysqlapi.worktual.co.uk/myaccount-mysql/v1/onboard/Urmyaccwebuserextesiondelete";
  let PURCHASED_ACCESS= "https://mysqlapi.worktual.co.uk/myaccount-mysql/v1/billing/getBillServicePlan";
  let SOCIAL_MEDIA_MYACC_API="https://mysqlapi.worktual.co.uk/myaccount-mysql/v1/login/social_account_login";
  let DOMAIN_URL ="https://app.worktual.co.uk";
  let TPI_PRIVATE_APP_URL ='https://api.worktual.co.uk/services/v1/apps';

  if (process.env.REACT_APP_ENV === "development") {
    
    API_URL = "https://stageurapi.worktual.co.uk";
    CHAT_RESTAPI_URL = "https://stageurapi.worktual.co.uk/urchat/v2";
    MEET_RESTAPI_URL = "https://stageurapi.worktual.co.uk/urmeet/v2/meetings";
    URCHAT_SOCKETIO_URL = "https://stageurapi.worktual.co.uk";
    // CALL_SERVER_WSS_URL = "wss://stagingwebrtc.worktual.co.uk:57344";
    //CALL_SERVER_WSS_URL = 'wss://testtls.worktual.co.uk:57344';
    CALL_SERVER_WSS_URL = 'wss://testvidsgw.worktual.co.uk:57344';
    // CALL_SERVER_WSS_URL = "wss://telewebrtc.worktual.co.uk:57344";
    meetingDomain = 'https://qameet.qaworktual.co.uk'
    MyAccountURL="https://myaccount.qaworktual.co.uk";
    APPID = "795623";
    AppSECRET = "8LkSh9I0cT";
    MyAccountURL='https://myaccount.qaworktual.co.uk';
    SOCIAL_MEDIA_MYACC_API="https://mysqlapi.worktual.co.uk/myaccount-mysql/v1/login/social_account_login";
    DOMAIN_URL="https://stagerevamp.worktual.co.uk";

  } else if (process.env.REACT_APP_ENV === "qastaging") {
    API_URL = "https://qaurapi.worktual.co.uk";
    CHAT_RESTAPI_URL = "https://qaurapi.worktual.co.uk/urchat/v2";
    MEET_RESTAPI_URL = "https://qaurapi.worktual.co.uk/urmeet/v2/meetings";
    URCHAT_SOCKETIO_URL = "https://qaurchat-io.worktual.co.uk";
    meetingDomain = 'https://qameet.qaworktual.co.uk';
    CALL_SERVER_STUN_URL_V4 = "turn:audioturnv4.worktual.co.uk:3478";
    CALL_SERVER_STUN_URL_V6 = "turn:audioturnv6.worktual.co.uk:3478";
    CALL_SERVER_WSS_URL =  'wss://testwebrtc1.worktual.co.uk:57344';
    // CALL_SERVER_WSS_URL = "wss://testsgw8.worktual.co.uk:57344";
    MyAccountURL="https://myaccount.qaworktual.co.uk";
    // CALL_SERVER_WSS_URL = "wss://lwssslp.worktual.co.uk:57344";
    //  CALL_SERVER_WSS_URL =  'wss://umnstage.worktual.co.uk:57344';
    //  CALL_SERVER_WSS_URL =  'wss://telewebrtc.qaworktual.co.uk:57344';

    MyAccountURL='https://myaccount.qaworktual.co.uk'
    DEACTIVATED_URL = "https://mysqlapi.worktual.co.uk/qamyaccount-mysql/v1/onboard/Urmyaccwebuserextesiondelete"
    // API_URL = "https://urapi.qaworktual.co.uk";
    // CHAT_RESTAPI_URL = "https://urapi.qaworktual.co.uk/urchat/v2";
    // URCHAT_SOCKETIO_URL = "https://urchat-io.qaworktual.co.uk";
    // CALL_SERVER_WSS_URL = "wss://telewebrtc.worktual.co.uk:57344";
    PURCHASED_ACCESS='https://mysqlapi.worktual.co.uk/qamyaccount-mysql/v1/billing/getBillServicePlan';
    SOCIAL_MEDIA_MYACC_API="https://mysqlapi.worktual.co.uk/myaccount-mysql/v1/login/social_account_login";
    DOMAIN_URL="https://qastageapp.qaworktual.co.uk";
    TPI_PRIVATE_APP_URL  = 'https://qaapi.worktual.co.uk/services/v1/apps'
  }
  return {
    CALL_SERVER_WSS_URL,
    CALL_SERVER_STUN_URL_V4,
    CALL_SERVER_STUN_URL_V6,
    CALL_SERVER_STUN_USERNAME,
    CALL_SERVER_STUN_PASSWORD,
    CALL_SERVER_USER_AGENT,
    CALLER_ID,
    UNKNOW_CALLER,
    CALL_LOG_MISSED,
    CALL_LOG_INCOMING,
    CALL_LOG_OUTGOING,
    CALL_INVALID_NUMBER,
    SELF_USER_NUMBER,
    ENTER_VALID_NUMBER,
    DEVICE_ALERT,
    FEATURE_IMP_ALTER,
    FILEUPLOADFAIL,
    ADHOC_CONF_MERGE_ALERT,
    CALL_LOG_DELETED_SUCCESS,
    CALL_LOG_SELECTION_ALERT,
    CALL_LOGALL_DELETED_SUCCESS,
    VOICEMAIL_READ,
    VOICEMAIL_UNREAD,
    VOICEMAIL_DELETED,
    QUEUELOG_DELETED,
    VOICEMAIL_SHARED,
    RECORDING_DELETED,
    UR_WEB,
    UR_ANDROID,
    UR_IOS,
    DESK_PHONE,
    API_URL,
    CHAT_RESTAPI_URL,
    MEET_RESTAPI_URL,
    TRY_AGAIN,
    ADD_CALL,
    CALL_TRANSFER,
    GOOGLE_API_URL,
    GOOGLE_COOKIE,
    GOOGLE_DEVELOPER_KEY,
    GOOGLE_CLIENTID,
    GOOGLE_APPID,
    GOOGLE_SCOPE,
    APPID,
    HELPCENTER,
    ABOUT,
    AppSECRET,
    TEAMCREATIONSUCCESS,
    TEAMCREATIONFAIL,
    REMOVEPROFILE,
    NOTESUCCESS,
    NOTEFAIL,
    NOTEUPDATE,
    NOTEDELETE,
    TASKDELETE,
    EVENTDELETE,
    TASKSUCCESS,
    TASKEDIT,
    EVENTCREATE,
    EVENTEDIT,
    DELETEMESSAGE,
    SHAREMESSAGE,
    APIFAILURE,
    FILEDELETED,
    IMAGEDELETED,
    URCHAT_SOCKETIO_URL,
    ACCEPTED_FILE_TYPE,
    ADD_FAV,
    REMOVE_FAV,
    TPICB_URL,
    COPYINVITATION,
    settingUp,
    meetingDomain,
    queryBoxUrl,
    BOX_CLIENT_ID,
    BOX_AUTH_URL,
    BOX_BASE_URL,
    MyAccountURL,
    BOX_CLIENT_SECRET,
    DEACTIVATED_URL,
    PURCHASED_ACCESS,
    SOCIAL_MEDIA_MYACC_API,
    DOMAIN_URL,
    CCAASS_URL,
    TPI_PRIVATE_APP_URL
  };
};
export const GetGif = (searchString: string) => {
  return "https://api.giphy.com/v1/gifs/search?q=" + searchString + "&api_key=B7GTUROA63ZC3sbQRALG7LrmWML2TSWO&rating=pg-13";
};
